import React from 'react';
import { useTranslation } from 'react-i18next';

const PackageSelector = ({ packages, selectedPackageId, onPackageChange }) => {
  const { t } = useTranslation();

  return (
    <div className="pkg-grid">
      <div className="pkg-grid__title">{t('labels.chooseYourPackage')}</div>
      <div className="pkg-grid__cards">
        {packages.map(pkg => (
          <div
            key={pkg.id}
            className={`pkg-card${selectedPackageId === pkg.id ? ' pkg-card--active' : ''}`}
            onClick={() => onPackageChange(pkg.id)}
          >
            <span className="pkg-card__nights">{pkg.nights}</span>
            <span className="pkg-card__nights-label">{t('labels.nights')}</span>
            <span className="pkg-card__desc">{pkg.description}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PackageSelector;
